<template>
    <div>
        <DekstopTestimony v-if="!isMobile" />
        <MobileTestimony v-if="isMobile" />
    </div>
  </template>
  
  <script>
  import DekstopTestimony from "@/components/testimony/desktop/Testimony.vue"
  import MobileTestimony from "@/components/testimony/mobile/Testimony.vue"
  
  export default {
    components: {
        DekstopTestimony,
        MobileTestimony,
    },
    data() {
        return {
            isMobile: false,
        };
    },
    metaInfo() {
    const thisPath = window.location.href
    return {
      title: this.$route.meta.title,
      htmlAttrs: { lang: "id", amp: true },
      meta: [
        { name: "description", content: this.$route.meta.description },
      ],
      link: [
        {
          rel: 'canonical',
          href: thisPath
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": this.$route.meta.title,
            "url": thisPath
          }
        }
      ]
    };
  },
    methods: {
        handleView() {
            this.isMobile = window.innerWidth <= 990;
        },
    },
    mounted() {
        this.$gtag.pageview(this.$route);
        this.$utils.scrollTop()
    },
    beforeMount() {
        this.handleView();
    },
  };
  </script>